<template>
  <div
    v-show="show"
    class="absolute bottom-0 bg-white z-[99] p-3 flex flex-col"
  >
    <div class="items-center flex flex-row justify-between">
      <h3>Debug info</h3>
      <button @click="show = false">
        Sluiten
      </button>
    </div>
    <div class="flex flex-row gap-2">
      <div>
        <h3>Build</h3>
        <table>
          <tbody>
            <tr>
              <td>Build timestamp</td>
              <td>{{ timestamp }}</td>
            </tr>
            <tr>
              <td>Build version</td>
              <td>{{ buildVersion }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <h3>State</h3>
        <table>
          <tbody>
            <tr>
              <td>Session token</td>
              <td>{{ accessToken }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const [timestamp, buildVersion] = [
  __APP_BUILD_TIMESTAMP__,
  __APP_BUILD_VERSION__,
];

onKeyStroke("F12", (e) => {
  e.preventDefault();
  show.value = !show.value;
});
const show = ref(false);

const accessToken = localStorage.getItem("qfood-session-token");
</script>

<style scoped>
table {
  border-collapse: collapse;
  border-spacing: 0;
}

td {
  border: 1px solid #ddd;
  padding: 5px;
}

td:first-child {
  font-weight: bold;
  text-align: right;
}

tr:nth-child(odd) {
  background-color: #f2f2f2;
}
</style>
